// 参考文档：https://kazupon.github.io/vue-i18n/zh/introduction.html
import zhCN from "./zh-cn";
import enUs from "./en-us";
import ptBr from "./pt-br";

export default {
  "zh-cn": zhCN,
  "en-us": enUs,
  "pt-br": ptBr,
};
